import { useState } from 'react';
import { testimonials } from '@/mocks/articles';
import { useInView } from '@/hooks/useInView';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex] || testimonials[0];
  const [ref, isInView] = useInView();

  return (
    <section ref={ref} className="relative bg-background-100 py-16 md:py-20">
      <div className={`max-w-[1400px] mx-auto px-6 md:px-10 transition-all duration-700 ease-out ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl italic text-foreground-950">
            ( Trusted Reviews )
          </h2>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="flex items-start gap-2 mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-900 text-background-50">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`text-sm ${star <= Math.floor(current.rating) ? 'ri-star-fill text-accent-400' : 'ri-star-line text-background-400'}`}
                ></i>
              ))}
              <span className="text-sm font-semibold whitespace-nowrap ml-1">{current.rating}/5.0</span>
            </div>
          </div>

          <blockquote className="font-heading text-lg md:text-xl italic text-foreground-700 leading-relaxed mb-8">
            &ldquo;{current.content}&rdquo;
          </blockquote>

          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <img
                src={current.avatarUrl}
                alt={current.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{current.name}</p>
              <p className="text-xs text-foreground-500">{current.role}</p>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 flex items-center gap-2">
            <button
              onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
              disabled={currentIndex === 0}
              className="w-11 h-11 rounded-lg border border-background-300 bg-background-50 flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-default"
            >
              <i className="ri-arrow-left-line text-lg text-foreground-600"></i>
            </button>
            <button
              onClick={() => setCurrentIndex(Math.min(testimonials.length - 1, currentIndex + 1))}
              disabled={currentIndex >= testimonials.length - 1}
              className="w-11 h-11 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-default"
            >
              <i className="ri-arrow-right-line text-lg text-background-50"></i>
            </button>
          </div>

          <div className="mt-8 flex items-center justify-center gap-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  idx === currentIndex ? 'bg-foreground-900 w-6' : 'bg-background-300 hover:bg-background-400'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}